import React from 'react';
import { Container } from 'react-bootstrap';
import { FiBookOpen, FiClock } from 'react-icons/fi';
import SectionHeader from './common/SectionHeader';
import useScrollRail from '../hooks/useScrollRail';
import { WIKI_ARTICLES } from '../api/fallback';

export default function WikiSection({ articles = WIKI_ARTICLES }) {
  const { railRef, canPrev, canNext, scrollPrev, scrollNext } = useScrollRail();

  return (
    <section className="mm-section" id="wiki">
      <Container>
        <SectionHeader
          eyebrow="Learn"
          title="From the Wiki"
          subtitle="Plain-language explainers written by clinicians, reviewed twice a year."
          actionLabel="All Wiki"
          onAction={() => {}}
          onPrev={scrollPrev}
          onNext={scrollNext}
          canScrollPrev={canPrev}
          canScrollNext={canNext}
          controlsLabel="articles"
        />

        <div
          className="mm-rail"
          ref={railRef}
          tabIndex={0}
          role="group"
          aria-label="Wiki articles, scrollable horizontally"
        >
          {articles.map((article) => (
            <div className="mm-rail__item" data-rail-item key={article.id}>
              <a
                href={`#wiki-${article.id}`}
                className="mm-wiki-card text-decoration-none"
              >
                <div className={`mm-wiki-card__cover mm-wiki-card__cover--${article.cover}`}>
                  <FiBookOpen size={38} aria-hidden="true" />
                </div>

                <div className="mm-wiki-card__body">
                  <span className="mm-wiki-card__tag">{article.tag}</span>
                  <h3 className="mm-wiki-card__title">{article.title}</h3>
                  <p className="mm-wiki-card__excerpt">{article.excerpt}</p>
                  <div className="mm-wiki-card__meta">
                    <FiClock size={13} aria-hidden="true" />
                    {article.readTime}
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
